import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router';
import { DirectoryOrganizations } from '../components/DirectoryOrganizations';

export const DirectoryOrganizationsPage: FC<RouteComponentProps> = ({ history }): JSX.Element => (
  <DirectoryOrganizations history={history} />
);
